import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=3113f53c&scoped=true"
import script from "./OffersView.vue?vue&type=script&lang=js"
export * from "./OffersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3113f53c",
  null
  
)

export default component.exports